import { Button, Col, Form, Input, Row, Space, theme, Table, Select, Tooltip, message, DatePicker, Tag, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { DATE_FORMAT, FORMAT_DATE, HeaderTableChildCus, HeaderTableChildCusL3, HeaderTableCus, LIST_SEX } from '../../constants/constants';
import { DeleteOutlined, SearchOutlined, TransactionOutlined } from '@ant-design/icons';
import { filterOption, formatNumber, getSelectedBranch, isAdmin } from '../../utils/funcHelper';
import dayjs from 'dayjs';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import { useSelector } from 'react-redux';
import { add_payment, cancel_payment, customer_services_detail, customer_services_update_status, debt_list, get_info_debt_detail, get_payment_detail, getListAccount, getListBranches } from '../../services/apis';
import ServiceDetailModal from './modal/ServiceDetailModal';
import PaymentDebtModal from './modal/PaymentDebtModal';
import PaymentCancelModal from './modal/PaymentCancelModal';
import PaymentDetailModal from './modal/PaymentDetailModal';



const ListCustomerLogsPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();

    const initialValues = {
        date: [dayjs().startOf('day'), dayjs().endOf('day')],
        branch_id: getSelectedBranch()?.id ?? null,
    };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);
    const userReducer = useSelector((state) => state?.userReducer?.data);
    const [employees, setEmployees] = useState([]);
    const [isShowModalDetailService, setIsShowModalDetailService] = useState(false);
    const [dataPositions, setDataPositions] = useState([]);
    const [dataBranches, setDataBranches] = useState([]);
    const [isOpenPaymentModal, setIsOpenPaymentModal] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
    const [cancelPaymentRecord, setCancelPaymentRecord] = useState(null);
    const [isOpenPaymentDetailModal, setIsOpenPaymentDetailModal] = useState(false);
    const [paymentDetailRecord, setPaymentDetailRecord] = useState(null);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [expandedServiceRowKeysMap, setExpandedServiceRowKeysMap] = useState({}); // NEW: lưu expanded keys của bảng dịch vụ theo customer_id
    const { RangePicker } = DatePicker;
    const columns = [
        // {
        //     title: 'STT',
        //     align: 'center',
        //     width: 20,
        //     render: (text, record, index) => <div>{(currentPage - 1) * currentPageSize + index + 1}</div>,
        // },
        {
            title: 'Tên khách hàng',
            dataIndex: 'customer_name',
            key: 'customer_name',
            width: 200,
            render: (text, record, index) => <div
                style={{
                    paddingLeft: 0, paddingRight: 12
                }}>
                <strong>{text}</strong>
            </div>,
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'phone',
            key: 'phone',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                {text}
            </div>,
        },
        {
            title: 'Giới tính',
            dataIndex: 'gender',
            key: 'gender',
            width: 120,
            align: 'center',
            render: (text, record, index) => <div>{text ? LIST_SEX.find(item => item.value === text).label : ''}</div>
        },
        {
            title: 'Nợ còn lại',
            dataIndex: 'total_debt',
            key: 'total_debt',
            width: 100,
            align: 'center',
            render: (text, record, index) => <strong style={{ color: 'red' }}>{formatNumber(text, 0)}</strong>,
        },
        {
            title: 'Địa chỉ',
            dataIndex: 'address',
            key: 'address',
            width: 120,
            render: (text, record, index) => <div>{text?.length > 50 ?
                <Tooltip
                    placement="topLeft"
                    title={text}
                >
                    <span>{text?.substring(0, 50)}...</span>
                </Tooltip> : `${text}`
            }</div>,
        }
    ];

    // Bảng payments trong từng dịch vụ
    const paymentColumns = [
        {
            title: 'STT',
            width: 60,
            align: 'center',
            render: (t, r, i) => i + 1,
        },
        {
            title: 'Ngày thanh toán',
            dataIndex: 'payment_date',
            key: 'payment_date',
            width: 140,
            align: 'center',
            render: (text, record) => {
                return text ? dayjs(text).format(DATE_FORMAT.DDMMYYYY_FORMAT) : '';
            }
        },
        {
            title: 'Mã phiếu',
            dataIndex: 'payment_code',
            key: 'payment_code',
            align: 'center',
            render: (text, record) => <a onClick={() => handleGetDetailPayment(record)}><span>{text || ''}</span></a>,
        },
        {
            title: 'Nội dung',
            dataIndex: 'note',
            key: 'note',
            render: (text, record) => <span>{text || ''}</span>,
        },
        {
            title: 'Số tiền (vnđ)',
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            render: (text, record) => <strong>{formatNumber(text, 0)}</strong>
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (text, record) => <Tag color={text === 'completed' ? 'green' : 'red'}>{text === 'completed' ? 'Đã thanh toán' : 'Đã huỷ'}</Tag>,
        },
        {
            title: 'Người thu tiền',
            dataIndex: 'received_by_name',
            key: 'received_by_name',
            align: 'center',
            render: (text, record) => <span>{text}</span>,
        },
        {
            title: 'Hành động',
            key: 'action',
            width: 100,
            align: 'center',
            render: (text, record) => (
                <Space size="middle">
                    {
                        record?.status === 'completed' ?
                            <Popconfirm
                                title="Bạn có chắc chắn muốn huỷ phiếu thanh toán này?"
                                onConfirm={(e) => {
                                    e.stopPropagation();
                                    openCancelPaymentModal(record);
                                }}
                                okText="Có"
                                cancelText="Không"
                            >
                                <a style={{ color: 'red' }}><DeleteOutlined /> Huỷ phiếu</a>
                            </Popconfirm> : null
                    }


                </Space>
            ),
        }
    ];

    const expandColumns = [
        {
            title: 'STT',
            width: 60,
            align: 'center',
            render: (t, r, i) => i + 1,
        },
        {
            title: 'Dịch vụ sử dụng',
            dataIndex: 'service_name',
            key: 'service_name',
            render: (text, record, index) => <div style={{
                display: 'flex', flexDirection: 'column', cursor: 'pointer'
            }}>
                <div style={{
                    paddingLeft: 6, paddingRight: 12, wordWrap: "break-word",
                    whiteSpace: "normal",
                }}><Tooltip title={text}><a>{text?.length > 100 ? text?.substring(0, 100)?.concat("...") : text}</a></Tooltip></div>
            </div>,
        },
        {
            title: 'Chi nhánh',
            dataIndex: 'branch_name',
            key: 'branch_name',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                {text}
            </div>,
        },
        {
            title: 'Nợ ban đầu',
            dataIndex: 'remaining_system',
            key: 'remaining_system',
            align: 'center',
            render: (text, record, index) => <div style={{ textAlign: 'end' }}>{text ? formatNumber(text, 0) : 0}</div>,
        },
        {
            title: 'Tổng thanh toán',
            dataIndex: 'total_paid',
            key: 'total_paid',
            align: 'center',
            render: (text, record, index) => <div style={{ textAlign: 'end' }}>{text ? formatNumber(text, 0) : 0}</div>,
        },
        {
            title: 'Nợ còn lại',
            dataIndex: 'real_remaining',
            key: 'real_remaining',
            align: 'center',
            render: (text, record, index) => <div style={{ textAlign: 'end' }}><strong>{text ? formatNumber(text, 0) : 0}</strong></div>,
        },
        {
            title: 'Hành động',
            key: 'action',
            width: 100,
            align: 'center',
            render: (text, record) => (
                <Space size="middle">
                    <a onClick={(e) => {
                        e.stopPropagation();
                        handlePayment(record);
                    }}><TransactionOutlined /> Thanh toán</a>
                </Space>
            ),
        }
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    // Mở modal huỷ phiếu
    const openCancelPaymentModal = (record) => {
        if (isAdmin(userReducer)) {
            setCancelPaymentRecord(record);
            setIsOpenCancelModal(true);
            return;
        } else {
            message.error('Chỉ có quản trị viên mới có quyền huỷ phiếu thanh toán');
        }
    };

    const handleGetDetailPayment = async (record) => {

        try {
            const params = {
                payment_id: record?.payment_id,
            };
            setLoading(true);
            const res = await get_payment_detail(params);
            if (res && res.status === 1) {
                setPaymentDetailRecord(res?.data);
                setIsOpenPaymentDetailModal(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        } finally {
            setLoading(false);
        }

        
    }

    const getDataServiceDetail = async (service_id) => {

        try {
            const params = {
                id: service_id,
            }
            setLoading(true);
            const res = await customer_services_detail(params);
            if (res && res.status === 1) {
                setItemSelected(res?.data);
                setIsShowModalDetailService(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil("error", error);
        } finally {
            setLoading(false);
        }

    }

    // Xác nhận huỷ phiếu (submit từ modal)
    const handleConfirmCancelPayment = async (reason) => {
        try {
            const params = {
                payment_id: cancelPaymentRecord?.payment_id,
                cancelled_reason: reason?.trim(),
                cancelled_by: userReducer?.user_info?.id,
            };
            setLoading(true);
            const res = await cancel_payment(params);
            if (res && res.status === 1) {
                message.success('Huỷ phiếu thanh toán thành công');
                setIsOpenCancelModal(false);
                setCancelPaymentRecord(null);
                getDataCustomerDebt(1, true);
            } else {
                message.error(res?.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        } finally {
            setLoading(false);
        }
    };

    const handlePayment = async (record) => {
        consoleLogUtil("record payment", record);
        try {
            const params = {
                customer_service_id: record?.customer_service_id,
            }
            setLoading(true);
            const res = await get_info_debt_detail(params);
            consoleLogUtil("res payment", res);
            if (res && res.status === 1) {
                setPaymentData(res?.data);
                setIsOpenPaymentModal(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        } finally {
            setLoading(false);
        }
    }

    const getDataCustomerDebt = async (page, showLoading, pageSize) => {
        try {
            const params = {
                keyword: form.getFieldValue('keyword') ?? null,
                branch_id: form.getFieldValue('branch_id') ?? null,
                from_date: form.getFieldValue('date') ? dayjs(form.getFieldValue('date')[0]).startOf('day').format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT) : null,
                to_date: form.getFieldValue('date') ? dayjs(form.getFieldValue('date')[1]).endOf('day').format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT) : null,
                page: page ?? currentPage,
                limit: pageSize ?? currentPageSize,
            }
            if (showLoading) setLoading(true);
            const res = await debt_list(params);
            if (showLoading) setLoading(false);
            consoleLogUtil("res debt_list", res);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
                setTotalRecords(res?.data?.pagination?.total_records ?? 0);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
                setTotalRecords(0);
            }
        } catch (error) {

        }

    }

    const getDataUsers = async () => {
        try {
            const params = {
                keyword: '',
                branch_id: getSelectedBranch()?.id ?? null,
                limit: 100,
                currentPage: 1,
            }

            const res = await getListAccount(params);
            if (res && res.status === 1) {
                setEmployees([...res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.fullname }))]);
            } else {
                setEmployees([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const onFinish = async (dataForm) => {
        setCurrentPage(1);
        getDataCustomerDebt(1, true);
    };

    const handleSaveServiceDetail = async (data) => {
        try {
            const params = {
                id: data?.id,
                status: data?.status,
                updated_by: userReducer?.user_info?.id
            }
            setLoading(true);
            const res = await customer_services_update_status(params);
            if (res && res.status === 1) {
                message.success('Cập nhật dịch vụ thành công');
                getDataCustomerDebt(1, true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil("error", error);
        } finally {
            setLoading(false);
        }
    }

    const getDataBranches = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await getListBranches(params);
            if (res && res.status === 1) {
                setDataBranches([...res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.name }))]);
            } else {
                setDataBranches([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }

    const ExpandedTable = React.memo(({ customerId, columns, dataSource }) => {
        const expandedRowRenderChild = (record) => {
            const payments = record?.payments || [];
            if (!payments.length) {
                return <div style={{ paddingLeft: 12 }}>Không có phiếu thanh toán</div>;
            }
            return (
                <Table
                    components={HeaderTableChildCusL3}
                    columns={paymentColumns}
                    dataSource={payments}
                    size="small"
                    pagination={false}
                    rowKey={(r, idx) => r?.id || r?.payment_id || idx}
                />
            );
        };

        return (
            <Table
                components={HeaderTableChildCus}
                columns={columns}
                dataSource={dataSource}
                bordered
                pagination={false}
                rowKey={(record) => record?.customer_service_id}
                expandable={{
                    expandedRowRender: expandedRowRenderChild,
                    expandRowByClick: false,
                    // NEW: kiểm soát expand của bảng dịch vụ theo customer
                    expandedRowKeys: expandedServiceRowKeysMap[customerId] || [],
                    onExpandedRowsChange: (keys) => {
                    setExpandedServiceRowKeysMap((prev) => ({ ...prev, [customerId]: keys }));
                    },
                }}
                onRow={(record) => {
                    return {
                        onClick: () => {
                            // Giữ hành vi mở chi tiết dịch vụ nếu cần
                            // getDataServiceDetail(record?.customer_service_id);
                        },
                        onMouseEnter: (event) => {
                            event.currentTarget.style.cursor = 'pointer';
                        },
                    };
                }}
            />
        );
    });

    const expandedRowRender = (record) => {
        const childData = record.services || [];

        return <ExpandedTable
            customerId={record.customer_id}
            columns={expandColumns}
            dataSource={childData}
        />
    };

    const handleSavePayment = async (data) => {
        try {
            const params = {
                ...data,
                received_by: userReducer?.user_info?.id,
            }
            setLoading(true);
            const res = await add_payment(params);
            if (res && res.status === 1) {
                message.success('Thêm phiếu thanh toán thành công');
                getDataCustomerDebt(1, true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataUsers(), getDataBranches()]).finally(() => setLoading(false));
    }, [])

    useEffect(() => {
        if (form) {
            form.setFieldsValue(initialValues);
            getDataCustomerDebt(1, true)
        }
    }, [form])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            name={'keyword'}
                        >
                            <Input
                                placeholder={'Nhập tên khách hàng, số điện thoại'}
                                className='custom-input-antd'
                            />

                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            name="branch_id"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn cơ sở'}
                                className='custom-input-antd'
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataBranches}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="date"
                        >
                            <RangePicker
                                format={FORMAT_DATE.DDMMYYYY}
                                allowClear={false}
                                className='custom-input-antd'
                            />
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                        <Space size="small">
                            <Tooltip title="Tìm kiếm">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className='custom-input-antd'
                                >
                                    <SearchOutlined /> Lọc dữ liệu
                                </Button>
                            </Tooltip>

                        </Space>
                    </Col>
                </Row>
            </Form>

            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                expandable={{ 
                    expandedRowRender,
                    expandedRowKeys,
                    onExpandedRowsChange: (keys) => setExpandedRowKeys(keys),
                    expandRowByClick: false,
                }}
                // rowSelection={rowSelection}
                bordered
                rowKey={(record) => record?.customer_id}
                scroll={{ x: 'max-content', y: 600 }}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => {

                        }, // click row
                        onMouseEnter: event => {
                            event.currentTarget.style.cursor = 'pointer';
                        }, // hover row
                    };
                }}
                pagination={{
                    pageSize: currentPageSize,
                    current: currentPage,
                    total: totalRecords,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        getDataCustomerDebt(page, true, size);
                    },
                    showSizeChanger: true,
                    showTotal: (total) => `Tổng ${total} khách hàng`,
                    pageSizeOptions: ['20', '30', '50'],
                    onShowSizeChange: (current, size) => {
                        setCurrentPageSize(size);
                        setCurrentPage(1);
                        getDataCustomerDebt(1, true, size);
                    }
                }}
            />

            <ServiceDetailModal
                visible={isShowModalDetailService}
                onClose={() => setIsShowModalDetailService(false)}
                data={itemSelected}
                employees={employees}
                positions={dataPositions}
                onSave={handleSaveServiceDetail}
            />

            <PaymentDebtModal
                isOpen={isOpenPaymentModal}
                onClose={() => setIsOpenPaymentModal(false)}
                data={paymentData}
                onSave={handleSavePayment}
            />
            <PaymentCancelModal
                isOpen={isOpenCancelModal}
                onClose={() => { setIsOpenCancelModal(false); setCancelPaymentRecord(null); }}
                onConfirm={handleConfirmCancelPayment}
                record={cancelPaymentRecord}
            />
            <PaymentDetailModal
                isOpen={isOpenPaymentDetailModal}
                onClose={() => { setIsOpenPaymentDetailModal(false); setPaymentDetailRecord(null); }}
                record={paymentDetailRecord}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListCustomerLogsPage);